
import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

interface YearFilterProps {
  selectedYear: string | null;
  onYearSelect: (year: string) => void;
  years: string[];
}

const YearFilter: React.FC<YearFilterProps> = ({
  selectedYear,
  onYearSelect,
  years,
}) => {
  // Sort years in descending order (newest to oldest)
  const sortedYears = [...years].sort((a, b) => b.localeCompare(a));

  return (
    <div className="w-full flex justify-center">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="w-[200px] flex items-center justify-between gap-2">
            <span className="flex-1 text-left truncate">{selectedYear || 'Select Year'}</span>
            <ChevronDown className="h-4 w-4 opacity-50" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent 
          align="center" 
          className="w-[200px] max-h-[300px] overflow-y-auto bg-white dark:bg-gray-800 shadow-lg z-50"
        >
          {sortedYears.map((year) => (
            <DropdownMenuItem
              key={year}
              className="px-4 py-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
              onClick={() => onYearSelect(year)}
            >
              {year}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default YearFilter;
